const css = ".collapse-slot {display:none;}";

export function init() {
  const head = document.head || document.getElementsByTagName("head")[0];
  injectCSS(head, getCSS());
}

function injectCSS(head, styleElem) {
  head.appendChild(styleElem);
}

function getCSS() {
  const style = document.createElement("style");
  style.appendChild(document.createTextNode(css));
  return style;
}
